import React, { useId } from 'react';
import { cn } from '../../utils/cn.ts';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: React.ReactNode;
    description?: string;
    error?: string;
    ref?: React.Ref<HTMLInputElement>;
}

const NativeInput = 'input';

export const Checkbox: React.FC<CheckboxProps> = ({
    label,
    description,
    error,
    className = '',
    disabled,
    id,
    ref,
    ...props
}) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const descriptionId = description ? `${inputId}-description` : undefined;
    const errorId = error ? `${inputId}-error` : undefined;
    const describedBy = [descriptionId, errorId].filter(Boolean).join(' ') || undefined;

    return (
        <div className={cn(
            'group inline-flex items-start',
            disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
            className
        )}>
            <div className="relative flex h-5 items-center">
                <NativeInput
                    type="checkbox"
                    ref={ref}
                    id={inputId}
                    disabled={disabled}
                    aria-describedby={describedBy}
                    className={cn(
                        'peer h-5 w-5 rounded',
                        'border-gray-300 dark:border-gray-600',
                        'bg-white dark:bg-surface-dark',
                        'text-primary',
                        'focus-ring transition-all',
                        'checked:border-primary checked:bg-primary',
                        'disabled:checked:bg-gray-400'
                    )}
                    {...props}
                />
            </div>
            
            {(label || description) ? <div className="ml-3 select-none text-sm">
                    {label ? <label htmlFor={inputId} className={cn(
                            'font-medium',
                            error ? 'text-red-500' : 'text-gray-900 transition-colors group-hover:text-primary dark:text-gray-100'
                        )}>
                            {label}
                        </label> : null}
                    {description ? <p id={descriptionId} className="mt-0.5 text-gray-500 dark:text-gray-400">
                            {description}
                        </p> : null}
                    {error ? <p id={errorId} className="mt-0.5 text-red-500 text-xs">
                            {error}
                        </p> : null}
                </div> : null}
        </div>
    );
};
